export default "__VITE_ASSET__CRiVXuMv__"